import $ from "jquery";

// フォームをsubmitしたらsubmit button にspinnerを表示
export default() => {
  $('form').submit(() => {
    $("button[type=submit]").addClass("is-loading");
  });
}
